import type { SxProps } from '@mui/material';

export const stickyStepperSx = {
  position: 'sticky',
  // -1 hides the sub-pixel seam above the stepper while scrolling
  top: -1,
  zIndex: 'appBar',
} satisfies SxProps;
